// @ts-nocheck
import { createHandlerChainRunnerOptionalParameter, Handler } from "@toolkit/Modules/client-framework/HandlerCreator";

type HandlerType = Handler;
export const DispatchCloseMinicartDrawer: HandlerType = props => {
    props.dispatch({
        type: "Store/Components/MinicartDrawer/closeMinicartDrawer",
    });
};
export const chain = [DispatchCloseMinicartDrawer];

const closeMinicartDrawer = createHandlerChainRunnerOptionalParameter(chain, {}, "CloseMinicartDrawer");
export default closeMinicartDrawer;
